// extracted by mini-css-extract-plugin
export default {"directoryBoxRow":"ciXNg","directoryItemName":"q0lo6","totalCount":"iuiVF"};